import styled from 'styled-components';

export const GameJackpotBarContainerDefaultBox = styled.div<{isOptInStatus?: boolean}>`
    width: 100%;

    @media ${({theme}) => theme.mediaQuery.landscape} {
      width: 80%;    
    }    

    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
      width: 40%;    
    }

    display: flex;     
    flex-direction: row;
    align-items: center;
    border-radius: 10px;
    color: ${({theme}) => theme.colors.text};
`;